import { FREE_CAPACITY_COCKPIT } from "~/utils/url/staticUrls";
import { useTranslation } from "react-i18next";
import { MyCompanyMenu } from "~/features/navigation/components/MyCompanyMenu";
import { useSimpleMenuState } from "~/common/components/Menu/Menu";
import { PersonalNavItem } from "~/features/navigation/components/headerMenu/PersonalNavItem";
import {
  FccAction,
  trackFccAction,
} from "~/features/freeCapacityPush/api/trackFccAction";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import { C_ON_SURFACE_VARIANT } from "~/common/components/icon/Colors";
import BallBearingIcon from "~/common/mui/icons/BallBearing";

const FCC = () => {
  const { t } = useTranslation();
  const showNew = window.SCHA.config.fccShowNewLabelEnabled;

  return (
    <a
      href={FREE_CAPACITY_COCKPIT}
      data-test-id={"free-capacity-cockpit"}
      onClick={() => trackFccAction(FccAction.IconClick)}
    >
      <PersonalNavItem
        data-test-id={"header-btn-free-capacity-cockpit"}
        icon={
          <BallBearingIcon sx={{ fontSize: 24, color: C_ON_SURFACE_VARIANT }} />
        }
        name={t("page.fcc.title")}
        badgeContent={showNew ? t("page.abmonitor.badge.new") : undefined}
        badgeVariant={"new"}
      />
    </a>
  );
};

const MyCompany = () => {
  const { t } = useTranslation();
  const [isOpen, handleClick, handleClose, anchorEl] = useSimpleMenuState();

  return (
    <>
      <PersonalNavItem
        name={t("header.link.my.company")}
        icon={<BusinessOutlinedIcon />}
        data-test-id={"header-btn-my-company"}
        onClick={handleClick}
      />
      <MyCompanyMenu open={isOpen} anchorEl={anchorEl} onClose={handleClose} />
    </>
  );
};

export const NavItems = {
  FCC,
  MyCompany,
};
